import { Component, Input } from '@angular/core';
import { Directionality } from '@angular/cdk/bidi';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent {
  @Input() value: number = 0;
  @Input() showBackdrop: boolean = true;
  @Input() compact: boolean = false;

  steps = [
    { label: 1, percentage: 10 },
    { label: 2, percentage: 32.5 },
    { label: 3, percentage: 55 },
    { label: 4, percentage: 77.5 },
    { label: 5, percentage: 100 },
  ];

  constructor(private directionality: Directionality) {}

  get displayValue(): number {
    return Math.min(100, Math.max(0, this.value));
  }

  get isRtl(): boolean {
    return this.directionality.value === 'rtl';
  }

  get thumbInlineStart(): string {
    const val = this.displayValue;
    return `calc(${val}% - (${val / 100} * 7px) + 3.5px)`;
  }

  get thumbTransform(): string {
    return this.isRtl ? 'translate(50%, -50%)' : 'translate(-50%, -50%)';
  }

  get tooltipTransform(): string {
    return this.isRtl ? 'translateX(50%)' : 'translateX(-50%)';
  }
}
